import { History } from "@mui/icons-material";
import { startCase } from "lodash";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip, MuiIconButton, NotificationBell } from "@ryde/controls";
import { useApplication, usePageTitle } from "@ryde/redux";
import {
  isCompanySelectDialogAvailableSelector,
  profileModalOpenStateAtom,
  TOOLTIP_DELAY_BUTTONS,
  useNotificationBell,
  useUserActionsHistoryBell,
} from "@ryde/shared";

import { DotsStyled } from "../header";
import { MobileHeaderStyled } from "./mobile.styled";
import { HamburgerMenu } from "./parts";

export const MobileHeader: FC = () => {
  const { t } = useTranslation();
  const { pageTitleTranslated } = usePageTitle();
  const { isAdminApp } = useApplication();
  const { isNotificationDrawerOpened, onMenuItemClick, isBadge, badgeContent } =
    useNotificationBell();
  const { onMenuItemClick: onHistoryClick, isUserActionsHistoryDrawerOpened } =
    useUserActionsHistoryBell();
  const isCompanySelectDialogAvailable = useRecoilValue(
    isCompanySelectDialogAvailableSelector,
  );
  const profileModalSetOpenState = useSetRecoilState(profileModalOpenStateAtom);
  const openProfileScopeModal = useEvent(() => {
    profileModalSetOpenState(true);
  });
  const title = startCase(pageTitleTranslated);

  return (
    <MobileHeaderStyled $isAdminApp={isAdminApp}>
      <HamburgerMenu />
      <h1 className="MobileHeader-Title">{title}</h1>
      <div className="MobileHeader-Actions">
        <MuiIconButton
          className="MobileHeader-History"
          onClick={onHistoryClick}
          aria-label={t("userActionsHistory.openRecentActivity")}
          aria-pressed={isUserActionsHistoryDrawerOpened}
        >
          <History fontSize="small" aria-hidden />
        </MuiIconButton>
        {isCompanySelectDialogAvailable && (
          <FramerTooltip
            content={t("general.SWITCH_COMPANY")}
            rtlStrippedBottomLeftPlacement
            mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
          >
            <DotsStyled
              className="MobileHeader-CompanySwitch"
              onClick={openProfileScopeModal}
            >
              <SVG_MUI.Dots9SVG />
            </DotsStyled>
          </FramerTooltip>
        )}
        <MuiIconButton
          className="MobileHeader-Notifications"
          onClick={onMenuItemClick}
        >
          <NotificationBell
            isBadge={isBadge}
            badgeContent={badgeContent}
            isActive={isNotificationDrawerOpened}
          />
        </MuiIconButton>
      </div>
    </MobileHeaderStyled>
  );
};
